import { ComposerPrimitive, useAuiState } from '@assistant-ui/react';

import { Button } from '@playbooks/ui/components/button';
import { Icon } from '@playbooks/ui/components/icon';

const ComposerControl = ({
	disabled = false,
	loading = false,
	onCancel = undefined,
	onClick = undefined,
	onSubmit = undefined,
	state = 'idle',
	submitAlt = 'Send',
	submitIcon = 'play',
	submitIconType = 'fas' as const,
	type = 'button' as const,
	...props
}) => {
	const running = state === 'running' || state === 'streaming';

	if (running) {
		return (
			<Button
				type='button'
				disabled={disabled}
				isLoading={loading}
				size='icon-xs'
				aria-label='Stop'
				onClick={onCancel || onClick}
				{...props}>
				<Icon data-icon='inline-start' type='fas' icon='stop' aria-hidden />
			</Button>
		);
	}

	return (
		<Button
			type={type}
			disabled={disabled}
			isLoading={loading}
			size='icon-xs'
			aria-label={submitAlt}
			onClick={onSubmit || onClick}
			{...props}>
			<Icon data-icon='inline-start' type={submitIconType} icon={submitIcon} aria-hidden />
		</Button>
	);
};

const ComposerAssistantControl = ({ disabled = false }) => {
	const running = useAuiState(state => state.thread.isRunning);

	if (running) {
		return <ComposerPrimitive.Cancel render={<ComposerControl disabled={disabled} state='running' />} />;
	}

	return <ComposerPrimitive.Send render={<ComposerControl disabled={disabled} submitAlt='Send' submitIcon='play' />} />;
};

export { ComposerAssistantControl, ComposerControl };
